import axios from "axios";

import { appConfig } from './config';
import * as utils from './utils';

const API_ENDPOINT = appConfig.appApi.tokenEndpoint;
const TOKEN_METHOD = utils.HTTP_METHOD.post;
const MD_METHOD = utils.HTTP_METHOD.get;
const API_METHOD = utils.HTTP_METHOD.post;
const TOKEN_HEADERS = utils.CT_FORM_HEADER;
const TOKEN_API_HEADERS = utils.CT_JSON_HEADER;

async function sendAuth(url, method, headers, data) {
  let result = {};
  try {
    const response = await axios({
      url: url, 
      method: method, 
      headers: headers,
      data: data
    });
    result = response.data; 
  } catch(error) {
    result = error.response;    
  }
  // console.log('result:', result); 
  return result;
}

export function getToken(url, params, headers) {
  const formBody = utils.buildFormBody(params);
  let tokenHeaders = headers ? {...TOKEN_HEADERS, ...headers} : TOKEN_HEADERS;
  return sendAuth(url, TOKEN_METHOD, tokenHeaders, formBody);
}

export function getMD(url) {
  return sendAuth(url, MD_METHOD);
}

export function getTokenFromAppApi(url, params, headers) {
  const body = {
    url: url,
    params: params,
    headers: headers
  }
  return sendAuth(API_ENDPOINT, API_METHOD, TOKEN_API_HEADERS,  JSON.stringify(body));
}
